import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Radio } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxjb25jZXJ0JTIwY3Jvd2R8ZW58MHx8fHwxNzkxNzU4OTk1fDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#080D1A] via-[#080D1A]/70 to-[#080D1A]/40" />
      <div className="absolute inset-0 bg-[#080D1A]/40" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-20 pt-32 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
          className="max-w-3xl"
        >
          <div className="mb-6 inline-flex items-center gap-2.5 border border-white/15 bg-white/5 px-4 py-2 backdrop-blur-sm">
            <Radio className="h-3.5 w-3.5 text-[#FF5500]" />
            <span className="font-ui text-[10px] font-bold uppercase tracking-[0.3em] text-white">
              Plataforma de batallas de gallos
            </span>
          </div>

          <h1 className="font-heading text-5xl font-black leading-[0.95] tracking-tighter text-white sm:text-6xl lg:text-7xl">
            LA REVOLUCIÓN
            <br />
            DEL <span className="text-[#FF5500]">FREESTYLE</span>
          </h1>

          <p className="mt-7 max-w-xl font-body text-base text-[#94A3B8] sm:text-lg">
            Gestiona competencias, registra la votación de los jueces en tiempo
            real y dale transparencia total a cada batalla. Puntuaciones,
            brackets y rankings en vivo, sin trampas.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contacto"
              data-testid="hero-cta-beta"
              className="group inline-flex items-center gap-2 bg-[#FF5500] px-7 py-4 font-ui text-xs font-bold uppercase tracking-[0.2em] text-white transition-transform duration-200 hover:-translate-y-1 hover:shadow-[0_14px_40px_-10px_rgba(255,85,0,0.7)]"
            >
              Probar Beta
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </a>
            <Link
              to="/eventos"
              data-testid="hero-cta-eventos"
              className="inline-flex items-center gap-2 border border-white/20 bg-white/5 px-7 py-4 font-ui text-xs font-bold uppercase tracking-[0.2em] text-white backdrop-blur-sm transition-colors duration-200 hover:border-[#FF5500] hover:text-[#FF5500]"
            >
              Ver Eventos en Vivo
            </Link>
          </div>
        </motion.div>
      </div>

      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#080D1A] to-transparent" />
    </section>
  );
}
